/** Shown in document titles and UI when `VITE_APP_NAME` is not set at build time. */
export const APP_DISPLAY_NAME = import.meta.env.VITE_APP_NAME ?? "Sidekick Searches";
